import { Alert, Button } from "react-bootstrap";
import { useHistory } from "react-router-dom";

import VisitorInfoSection from "./_components/VisitorInfoSection";

const VisitorViewPage = () => {
  const history = useHistory();

  const locationState = history.location.state || {};
  const visitor = locationState.visitor || null;

  const goBack = () => history.push("/jeep-rally/participants/visitors");

  if (!visitor) {
    return (
      <div className="container-fluid">
        <div className="card">
          <div className="card-body">
            <Alert variant="warning" className="mb-3">
              Visitor details are unavailable. Open a visitor from the list —
              individual visitor fetch is not supported yet.
            </Alert>
            <Button variant="primary" onClick={goBack}>
              Back to Visitors
            </Button>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="container-fluid">
      <div className="card">
        <div className="card-header d-flex align-items-center flex-wrap gap-2">
          <div className="d-flex align-items-center gap-2">
            <button
              type="button"
              className="btn btn-link p-0 text-decoration-none"
              onClick={goBack}
              aria-label="Back to visitors list"
              title="Back"
            >
              <i className="bi bi-arrow-left fs-4" />
            </button>
            <h4 className="card-title mb-0">
              {visitor.name || "Visitor Details"}
            </h4>
          </div>
        </div>

        <div className="card-body">
          <VisitorInfoSection visitor={visitor} />
        </div>
      </div>
    </div>
  );
};

export default VisitorViewPage;
